<template>
  <div>
    <div v-if="form"
      style="text-align: right;"
      dir="rtl"
    >
      <div>
        <p class="bold">History Company</p>
        <history-companies-search-box @selected="selectHistoryCompany" :selected_history_company_name="selected_history_company_name"></history-companies-search-box>
      </div>
      <div>
        <p class="bold">Year Start</p>
        <input
          v-model="form.data.history_company.fields.year_start.value"
          class="outlined"
          placeholder="Year Start"
        />
      </div>
      <div class="mb-4">
        <p class="bold">Year End</p>
        <input
          v-model="form.data.history_company.fields.year_end.value"
          class="outlined"
          placeholder="Year End"
        />
      </div>
      <div class="mb-4">
        <Checkbox
          v-model="form.data.history_company.fields.still_working.value"
          :checked="form.data.history_company.fields.still_working.value"
          >Still Working</Checkbox
        >
      </div>
      <div v-if="form.data.history_company.fields.still_working.value">
        <Checkbox
          v-model="form.data.history_company.fields.is_discrete.value"
          :checked="form.data.history_company.fields.is_discrete.value"
          >Is Discrete</Checkbox
        >
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading, faded: is_submitted }"
        class="button is-info"
        >Submit</a
      >
      <div>
        <a
          @click="submit(true)"
          :class="{ 'is-loading': is_loading, faded: is_submitted }"
          class="button is-warning mx-5"
          >Submit and Create Another One</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Checkbox from '@/components/Checkbox'
import HistoryCompaniesSearchBox from '@/components/HistoryCompaniesSearchBox'
export default {
  name: 'applicant-history-companies-form',
  props: {
    payload: {
      type: Object
    },
    onSubmit: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      is_loading: false,
      is_submitted: false,
      form: undefined,
      selected_history_company_name: '',
      applicant_id: this.payload.applicant_id
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: '',
          history_company: {}
        })
        return
      }
      this.$network_utils.getApplicantHistoryCompany({ applicant_history_company_id: this.payload.data.id, current_applicant_id: this.applicant_id })
        .then(response => {
          this.setForm(response)
          this.selected_history_company_name = response.history_company.name
          this.selectHistoryCompany(response.history_company)
        })
    },
    setForm (form_data) {
      this.form = new this.$form({
        history_company: {
          fields: {
            history_company_id: {
              value: form_data.history_company.id,
              has_error: false,
              validations: []
            },
            year_start: {
              value: form_data.year_start,
              has_error: false,
              validations: []
            },
            year_end: {
              value: form_data.year_end,
              has_error: false,
              validations: []
            },
            is_discrete: {
              value: form_data.is_discrete,
              has_error: false,
              validations: []
            },
            still_working: {
              value: form_data.still_working,
              has_error: false,
              validations: []
            },
            current_applicant_id: {
              value: this.payload.applicant_id,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/applicants/history_companies/' + form_data.id,
            headers: 'applicant_headers'
          },
          is_used: true
        }
      })
    },
    selectHistoryCompany (history_company) {
      this.form.data.history_company.fields.history_company_id.value = history_company.id
    },
    submit (create_another = false) {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.$utils.emit('show_toast', { text: 'success' })
        this.is_loading = false
        this.onSubmit()
        this.remove(this.payload)
        if (create_another) {
          this.create({
            designator: 'applicant-history-companies-form-modal',
            component_name: 'ApplicantHistoryCompaniesForm',
            is_create: true,
            applicant_id: this.applicant_id,
            modal_title: 'Create new History Company'
          })
        }
      })
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    Checkbox,
    HistoryCompaniesSearchBox
  }
}
</script>
